import type { MensajeStream } from '@tms/contratos';
import { API_URL, USAR_MOCK } from '../config';
import { ApiReal } from './real';
import type { ApiTms, EstadoConexion } from './types';

export * from './types';

const CLAVE_SESION = 'tms-sesion';

export function leerToken(): string | null {
  try {
    const bruto = localStorage.getItem(CLAVE_SESION);
    return bruto ? (JSON.parse(bruto) as { token?: string }).token ?? null : null;
  } catch {
    return null;
  }
}

let manejadorNoAutorizado: () => void = () => undefined;
/** La sesión registra qué hacer ante un 401 (volver al login). */
export function alNoAutorizado(fn: () => void): void {
  manejadorNoAutorizado = fn;
}

/**
 * Modo demostración: el mock (y sus trazas) se carga con import() dinámico, así queda en un chunk aparte
 * que el build de producción (VITE_USAR_MOCK=false) nunca descarga. Cada método espera a que cargue.
 */
function crearApiMock(): ApiTms {
  const cargar = import('./mock').then((m) => new m.ApiMock());
  return new Proxy({ esMock: true } as unknown as ApiTms, {
    get(_objetivo, prop) {
      if (prop === 'esMock') return true;
      if (prop === 'suscribir') {
        return (onMensaje: (m: MensajeStream) => void, onEstado?: (e: EstadoConexion) => void) => {
          let cerrar: (() => void) | null = null;
          let cerrado = false;
          void cargar.then((mock) => {
            if (!cerrado) cerrar = mock.suscribir(onMensaje, onEstado);
          });
          return () => {
            cerrado = true;
            cerrar?.();
          };
        };
      }
      return async (...args: unknown[]) => {
        const mock = await cargar;
        const fn = (mock as unknown as Record<string, (...a: unknown[]) => unknown>)[String(prop)];
        return fn.apply(mock, args);
      };
    },
  });
}

/** Instancia única de la capa de datos, según VITE_USAR_MOCK. */
export const api: ApiTms = USAR_MOCK ? crearApiMock() : new ApiReal(API_URL, leerToken, () => manejadorNoAutorizado());
export { CLAVE_SESION };
